export default {
    recordDetails: {
        enableInventory: "Enable inventory",
        inventoryDisabled: "Inventory tracking is off",
        inventoryEnabled: "Inventory enabled",
        inventorySaved: "Inventory adjustment saved",
        itemTitle: "Item details",
        expenseTitle: "Expense details",
        timeTitle: "Time entry details",
        information: "Details",
        receipt: "Receipt",
        inventoryHistory: "Inventory history",
        inventoryLoadFailed: "Unable to load inventory history.",
        noInventory: "No inventory activity yet",
        loadFailed: "Unable to load details.",
        deleteConfirm: "Delete this record?",
        deleted: "Record deleted"
    },
    common: {
        appName: 'Swift Invoice',
        back: 'Back',
        cancel: 'Cancel',
        email: 'Email',
        password: 'Password',
        or: 'or',
        change: 'Change',
        delete: 'Delete',
        save: 'Save',
        edit: 'Edit',
        add: 'Add',
        close: 'Close',
        date: 'Date',
        total: 'Total',
        status: 'Status',
        amount: 'Amount',
        quantity: 'Quantity',
        rate: 'Rate',
        tax: 'Tax',
        discount: 'Discount',
        note: 'Note',
        notes: 'Notes',
        noData: 'No data',
        description: 'Description',
        client: 'Client',
        item: 'Item',
        items: 'Items',
        type: 'Type',
        category: 'Category',
        phone: 'Phone',
        name: 'Name',
        subject: 'Subject',
        saveAndClose: 'Save and Close',
        saveAndSendEmail: 'Save and Send Email',
        sendEmail: 'Send email',
        send: 'Send',
        print: 'Print',
        moreActions: 'More actions',
        preparingPdf: 'Preparing PDF...',
        pdfPreparationFailed: 'Unable to prepare PDF',
        warning: 'Warning',
        ok: 'OK',
        uploadSuccess: 'upload success',
        uploadFailed: 'Upload failed. Please try again.',
        saveSuccess: 'save success',
        deleteSuccess: 'delete success',
        deleteFailed: 'delete failed',
        saveFailed: 'save failed',
        loadFailed: 'load failed',
        systemError: 'system error',
        sendSuccess: 'send success',
        updateSuccess: 'update success',
        unsavedChangesMsg: 'You have unsaved changes. Would you like to save or discard them?',
        saveChangesTitle: 'Save changes?',
        confirmSave: 'Save',
        discard: 'Discard',
        validEmail: 'Please enter a valid email address',
        deleteFailedMsg: 'delete failed',
        shipping: 'Shipping',
        attachment: 'Attachment',
        days: 'Days',
        excl: '(excl.)',
        incl: '(incl.)',
        of: 'of',
        batchActions: 'Batch actions',
        selected: 'selected',
        select: 'Select',
        batchDeleteConfirm: 'Delete {count} selected records?',
        batchActionSuccess: '{count} records updated',
        batchActionPartial: '{processed} records updated; {skipped} did not require changes',
        batchEmailInvalidRecipients: 'Add a valid recipient for every selected document',
        batchEmailSent: '{count} emails sent',
        batchEmailPartial: '{sent} emails sent; {failed} failed',
        emailHtmlNotAllowed: 'HTML is not allowed in the email subject or message.'
    },
    emailVerification: {
        title: 'Verify your email',
        description: 'We sent a verification code to your login email:',
        codePlaceholder: 'Enter verification code',
        enterCode: 'Enter the code from your email to continue.',
        sent: 'Verification code sent.',
        resent: 'A new verification code has been sent.',
        validFor: 'The code is valid for 10 minutes.',
        verify: 'Verify',
        resend: 'Resend',
        success: 'Email verified. Your email will now be sent.',
        failed: 'The verification code is incorrect or has expired.',
        limitReached: "You've reached today's resend limit.",
        remaining: '{count} sends remaining today',
        contactUs: 'Contact us'
    },
    login: {
        heroPrefix: 'Smart ',
        heroInvoicing: 'Invoicing',
        heroMiddle: ',',
        heroSimplified: 'Simplified',
        heroSuffix: ' for You.',
        subtitle1: 'Create, send, and manage invoices effortlessly.',
        subtitle2: 'Get paid faster with Swift Invoice.',
        feature1Title: 'Professional Invoices',
        feature1Text: 'Create beautiful invoices in minutes',
        feature2Title: 'Real-time Tracking',
        feature2Text: 'Track payments and invoice status',
        feature3Title: 'Secure & Reliable',
        feature3Text: 'Your data is safe with enterprise-grade security',
        welcomeBack: 'Welcome back',
        signInToContinue: 'Sign in to your account to continue',
        enterEmail: 'Enter your email',
        enterPassword: 'Enter your password',
        rememberMe: 'Remember me',
        forgotPassword: 'Forgot password?',
        signIn: 'Sign in',
        signingIn: 'Signing in…',
        continueWithGoogle: 'Continue with Google',
        continueWithApple: 'Continue with Apple',
        createAccount: 'Create account',
        startUsing: 'Start using Swift Invoice',
        companyName: 'Company name',
        enterCompanyName: 'Enter your company name',
        alreadyHaveAccount: 'Already have an account? Sign in',
        footerRights: '© 2026 Swift Invoice. All rights reserved.',
        termsOfService: 'Terms of Service',
        contactUs: 'Contact us: goodinvoicego@gmail.com',
        betaDialogBody: 'Our team completed the first version of the web <br> This version will only be available to iPhone users <br> We will improve the web function as soon as possible and open it to all <br>',
        ieDialogBody: 'Sorry, because IE browser has compatibility problems, we do not support IE browser at present, if you need to use, please download',
        resetPasswordTitle: 'Reset password',
        sendResetEmail: 'Send reset email',
        resetEmailSent: 'Reset password email sent. Please check your inbox.',
        bindingTitle: 'Link existing account',
        bindingHintPrefix: 'An account already uses the email ',
        bindingHintSuffix: ". Enter that account's password to link your Google sign-in.",
        enterAccountPassword: 'Enter account password',
        linkAccount: 'Link account',
        validEmail: 'Please enter a valid email address',
        validPassword: 'Password must be 6 characters or more',
        validCompanyName: 'Please fill in your company name',
        companyNameTooLong: 'Company name can contain up to {max} characters',
        turnstileUnavailable: 'The security check could not be loaded. Please try again.',
        turnstileExpired: 'The security check expired. Please complete it again.',
        accountDataLoadFailed: 'Your account was verified, but its business data could not be loaded. Please try again.'
    },
    account: {
        title: 'Account',
        profile: 'Profile',
        swiftAccount: 'Swift Invoice account',
        connectSocial: 'Connect social accounts',
        companyLogo: 'Company logo',
        logoSize: 'Logo size',
        hideBusinessName: 'Hide business name',
        businessNameSize: 'Business name size',
        sizeSmall: 'Small',
        sizeNormal: 'Normal',
        sizeBig: 'Big',
        addLogo: 'Add logo',
        uploading: 'uploading...',
        currentPlan: 'Current plan: Swift {plan}',
        planActiveUntil: 'Plan active until {date}',
        sharedWithMobile: 'Shared with mobile',
        subscriptionExpired: 'Your subscription has expired',
        planNote: 'Log in again if your subscription status has not been updated.',
        upgradeToPro: 'Upgrade to Swift Pro',
        viewPlans: 'View subscription plans',
        connecting: 'Connecting…',
        connectGoogle: 'Connect Google',
        googleConnected: 'Google connected',
        googleConnectedWithEmail: 'Google connected ({email})',
        connectApple: 'Connect Apple',
        appleConnected: 'Apple connected',
        appleConnectedWithEmail: 'Apple connected ({email})',
        logoUuidMissing: 'Company logo UUID is missing',
        googleConnectedToast: 'Google account connected.',
        appleConnectedToast: 'Apple account connected.',
        logoUploadEmpty: 'Please select an image.',
        logoUploadSize: 'The image cannot exceed 10 MB.',
        logoUploadType: 'Only JPEG, PNG, and BMP images are supported.',
        logoUploadFailed: 'The company logo could not be uploaded.',
        logoUnavailable: 'Logo file unavailable. Upload it again.',
        deleteAccount: 'Delete account',
        deleteAccountDescription: 'Permanently close your Swift Invoice account.',
        deleteAccountTitle: 'Delete account?',
        deleteAccountWarning: 'This action cannot be undone.',
        deleteAccountConfirm: 'Enter your password to confirm account deletion.',
        deleteAccountPasswordPlaceholder: 'Enter your password'
    },
    menu: {
        openNavigation: 'Open navigation',
        closeNavigation: 'Close navigation',
        invoices: 'Invoices',
        estimates: 'Estimates',
        purchaseOrders: 'Purchase Orders',
        creditMemos: 'Credit Memos',
        time: 'Time',
        items: 'Items',
        clients: 'Clients',
        expenses: 'Expenses',
        reports: 'Reports',
        settings: 'Settings',
        companyInfo: 'Company info',
        taxes: 'Taxes',
        default: 'Default',
        customizeInvoice: 'Customize invoice',
        sendFeedback: 'Send Feedback',
        newReply: '1 new reply',
        signOut: 'Sign out',
        signOutConfirm: 'Are you sure sign out?',
        addBusiness: 'Add business',
        newBusinessTitle: 'New business',
        businessName: 'Business name',
        businessNamePlaceholder: 'Enter the business name',
        createBusiness: 'Create',
        businessNameRequired: 'Enter the business name',
        createBusinessSuccess: 'Business created successfully',
        deleteBusiness: 'Delete business',
        deleteBusinessTitle: 'Delete business',
        deleteBusinessConfirm: 'Delete “{name}”?',
        deleteBusinessWarning: 'All data belonging to this business will be deleted.',
        deleteBusinessSuccess: 'Business deleted successfully',
        trialDaysLeft: '{days} days left in your trial',
        upgradeAccount: 'Upgrade Account'
    },
    network: {
        loginExpired: 'Login expired, please log in again',
        requestTimeout: 'Request timed out, please check the network'
    },
    language: {
        label: 'Language',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        listLoadFailed: 'Unable to load invoices.',
        summaryLoadFailed: 'Unable to load invoice totals.',
        invoiceNumberPlaceholder: 'Enter invoice #',
        filterAllClients: 'All clients',
        clientOptionsLoadFailed: 'Unable to load clients for filtering.',
        filterAllStatuses: 'All statuses',
        filterUnpaid: 'Unpaid',
        filterPaid: 'Paid',
        filterOverdue: 'Overdue',
        filterUnsent: 'Unsent',
        filterSent: 'Sent',
        filterStartDate: 'Start date',
        filterEndDate: 'End date',
        searchPlaceholder: 'Search your invoices',
        addInvoice: 'Add Invoice',
        overdueInvoices: 'Overdue invoices',
        paidInvoices: 'Paid invoices',
        unpaidInvoices: 'Unpaid invoices',
        unsentInvoices: 'Unsent invoices',
        columnNumber: 'Number',
        columnClient: 'Client',
        columnStatus: 'Status',
        statusFullyPaid: 'Fully paid',
        statusPartial: 'Partial',
        statusOverdue: 'Overdue',
        statusUnsent: 'UnSent',
        statusSent: 'Sent',
        statusOpened: 'Opened',
        actionRecordPayment: 'Record Payment',
        actionMarkAsSent: 'Mark as Sent',
        actionCopy: 'Copy',
        actionDelete: 'Delete',
        copyDialogTitle: 'Copy invoice',
        copyTargetType: 'Copy to',
        copyOptions: 'Copy options',
        copyClient: 'Copy client',
        copyItems: 'Copy items',
        copyAttachments: 'Copy attachments',
        confirmDelete: 'This will delete the invoice. Continue?',
        copySuccess: 'Invoice copied',
        copyFailed: 'Copy failed',
        deleteSuccess: 'Invoice deleted',
        deleteFailed: 'Delete failed',
        recordPaymentDialogTitle: 'Record Payment',
        markAsFullyPaid: 'Mark as fully paid',
        formAmount: 'Amount',
        formDate: 'Date',
        formPaymentMethod: 'Payment Method',
        formNote: 'Note',
        allYears: 'All years',
        errorNoOutstandingBalance: 'No outstanding balance is available for payment',
        errorInvalidPaymentAmount: 'Enter an amount greater than zero with up to 5 decimal places',
        dueDateToday: 'Today',
        dueDateDaysAgo: '{days} days ago',
        dueDateInDays: 'in {days} days'
    },
    estimate: {
        filterAllStatuses: 'All statuses',
        pageTitlePurchaseOrders: 'Purchase Orders',
        pageTitleEstimates: 'Estimates',
        pageTitleCreditMemos: 'Credit Memos',
        searchPlaceholderPurchaseOrders: 'Search your purchase orders',
        searchPlaceholderEstimates: 'Search your estimates',
        searchPlaceholderCreditMemos: 'Search your credit memos',
        addPurchaseOrder: 'Add purchase order',
        addEstimate: 'Add estimate',
        addCreditMemo: 'Add credit memo',
        columnNumber: 'Number',
        columnClient: 'Client',
        columnDate: 'Date',
        columnEmail: 'Email',
        columnStatus: 'Status',
        columnTotal: 'Total',
        statusUnsent: 'Unsent',
        statusSent: 'Sent',
        actionMarkAsSent: 'Mark as Sent',
        actionCopy: 'Copy',
        actionDelete: 'Delete',
        actionConvertToInvoice: 'Convert to Invoice',
        copyDialogTitle: 'Copy {document}',
        copyTargetType: 'Copy to',
        copyOptions: 'Copy options',
        copyClient: 'Copy client',
        copyItems: 'Copy items',
        copyAttachments: 'Copy attachments',
        confirmDelete: 'This will delete the {document}. Continue?',
        convertConfirm: 'Convert this {document} to an invoice? The issue date will be set to today.',
        copySuccess: '{document} copied',
        copyFailed: 'Copy failed',
        convertSuccess: '{document} converted to invoice',
        convertFailed: 'Convert failed',
        deleteSuccess: '{document} deleted',
        deleteFailed: 'Delete failed',
        dueDateToday: 'Today',
        dueDateDaysAgo: '{days} days ago',
        dueDateInDays: 'in {days} days'
    },
    item: {
        pageTitle: 'Items',
        searchPlaceholder: 'Search your items',
        addItem: 'Add item',
        columnInventoryCountUnit: 'Inventory Count/Unit',
        noDescription: 'NO ITEM DESCRIPTION'
    },
    client: {
        detailsTitle: 'Client details',
        contactDetails: 'Contact details',
        invoiceHistory: 'Invoice history',
        noInvoices: 'No invoices yet',
        retry: 'Try again',
        detailsLoadFailed: 'Unable to load client details.',
        invoicesLoadFailed: 'Unable to load invoices.',
        deleteConfirm: 'Delete this client?',
        deleted: 'Client deleted',
        pageTitle: 'Clients',
        searchPlaceholder: 'Search your clients',
        addClient: 'Add client',
        columnClientName: 'Client Name',
        columnEmail: 'Email',
        columnPhone: 'Phone',
        columnBalanceDue: 'Balance Due',
        noNameFallback: 'NO NAME'
    },
    expense: {
        pageTitle: 'Expenses',
        searchPlaceholder: 'Search your expenses',
        allCategories: 'All categories',
        noCategory: 'No Category',
        categoryLoadFailed: 'Unable to load expense categories.',
        addExpense: 'Add expense',
        columnDescription: 'Description',
        columnDate: 'Date',
        columnTotal: 'Total',
        tip: 'Tip'
    },
    report: {
        headerTitle: 'Reports',
        tabDashboard: 'Dashboard',
        tabReportList: 'Report list',
        export: 'Export',
        annualSalesByClient: 'Annual sales by client',
        otherClients: 'Other clients',
        totalOutstandingBalance: 'Total outstanding balance',
        invoicesCountSuffix: 'invoices',
        byMonth: 'By month',
        byQuarter: 'By quarter',
        noSalesFound: 'No sales found',
        filterReportTypes: 'Report types',
        filterTimePeriod: 'Time period',
        filterView: 'View',
        filterTaxYear: 'Tax year',
        filterQuarter: 'Quarter',
        filterMonth: 'Month',
        filterStartDate: 'Start date',
        filterEndDate: 'End date',
        invalidCustomDateRange: 'Start date must not be later than end date',
        searchClientName: 'Search client name',
        searchItemName: 'Search item name',
        searchSalesJournal: 'Search invoice number or client name',
        searchPaymentsJournal: 'Search invoice number, client name or payment type',
        periodMonth: 'Month',
        periodQuarter: 'Quarter',
        periodYear: 'Year',
        periodAllTaxYears: 'All Tax Years',
        periodCustom: 'Custom',
        taxYearLabel: 'Tax Year {year}',
        quarterLabel: 'Q{quarter} Tax Year {year}',
        optionMonthly: 'Monthly',
        optionQuarterly: 'Quarterly',
        customerAgingTitle: 'Customer Aging',
        noDataForDateRange: 'No data for this date range',
        typeSalesByDate: 'Sales by Date',
        typeSalesByClient: 'Sales by Client',
        typeSalesByItem: 'Sales by Item',
        typeSalesJournal: 'Sales Journal',
        typePaymentsByDate: 'Payments by Date',
        typePaymentsByClient: 'Payments by Client',
        typePaymentsByType: 'Payments by Type',
        typePaymentsJournal: 'Payments Journal',
        typeExpenseByCategory: 'Expense by Category',
        typeExpenseJournal: 'Expense Journal',
        typeProfitLoss: 'Profit Loss',
        typeTaxes: 'Taxes',
        typeCustomerAging: 'Customer Aging',
        allYears: 'All years',
        allTime: 'All time',
        allSales: 'All sales',
        taxYearSales: 'Tax year {year} sales',
        firstColumnMonth: 'Month',
        firstColumnQuarter: 'Quarter',
        firstColumnYear: 'Year',
        firstColumnDay: 'Day',
        firstColumnDate: 'Date',
        columnSubTotal: 'Sub Total',
        columnTax: 'Tax',
        columnDiscount: 'Discount',
        columnTotal: 'Total',
        columnAmountPaid: 'Amount Paid',
        columnAmountOwed: 'Amount Owed',
        columnClient: 'Client',
        columnItem: 'Item',
        columnUnitType: 'Unit Type',
        columnQuantity: 'Quantity',
        columnRateAvg: 'Rate (avg)',
        columnInvoiceDate: 'Invoice Date',
        columnInvoiceNo: 'Invoice No',
        columnType: 'Type',
        columnPaymentDate: 'Payment Date',
        columnCategory: 'Category',
        columnExpenseDate: 'Expense Date',
        columnMerchant: 'Merchant',
        columnDescription: 'Description',
        columnCurrentDue: 'Current Due',
        column1To30DaysOverdue: '1-30 Days Overdue',
        column31To60DaysOverdue: '31-60 Days Overdue',
        column61To90DaysOverdue: '61-90 Days Overdue',
        column91PlusDaysOverdue: '91+ Days Overdue',
        columnSection: 'Section',
        columnAmount: 'Amount',
        columnPreTaxSales: 'Pre Tax Sales',
        columnTaxLabel: 'Tax Label',
        columnTaxRate: 'Tax Rate',
        columnTotalTax: 'Total Tax',
        columnPostTaxTotal: 'Post Tax Total',
        profitLossTitle: 'Profit Loss',
        taxesTitle: 'Taxes',
        profitLossRevenue: 'Revenue',
        profitLossExpense: 'Expense',
        profitLossProfit: 'Profit',
        profitLossCash: 'Cash',
        profitLossAccrued: 'Accrued',
        profitLossAccountsReceivables: 'Accounts Receivables',
        profitLossNone: '[None]',
        profitLossTotalExpenses: 'Total Expenses',
        profitLossCashProfit: 'Cash Profit',
        profitLossAccruedProfit: 'Accrued Profit',
        monthNames: 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec',
        totalRowLabel: 'Total'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Add',
        initialDataLoadFailed: 'Unable to load document settings. Editing and saving are disabled.',
        searchSuggestionsLoadFailed: 'Search suggestions could not be loaded.',
        invoicePrefix: 'invoice prefix',
        tabCreate: 'Create',
        tabPreview: 'Preview',
        tabSendEmail: 'Send Email',
        sectionClient: 'Client',
        addClient: 'Add client',
        dialogClientInfo: 'Client information',
        basicInformation: 'Basic information',
        labelName: 'Name',
        labelEmail: 'Email',
        labelPhone: 'Phone',
        billingAddress: 'Billing address',
        labelLine1: 'Line 1',
        labelLine2: 'Line 2',
        labelLine3: 'Line 3',
        shippingAddress: 'Shipping address',
        labelShippingName: 'Shipping Name',
        labelNotes: 'Notes',
        placeholderCreateOrSelect: 'Create or select one...',
        placeholderClientNotes: "Add notes about the client. They can't see these",
        sectionItems: 'Items',
        saveToYourItem: 'Save to your item',
        stock: 'Stock:',
        placeholderItemCode: 'item code',
        placeholderQuantity: 'Quantity',
        placeholderRate: 'rate',
        placeholderInputDescription: 'Input description',
        placeholderInputComment: 'Input Comment',
        placeholderAddRecipient: 'Add recipient',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'Email subject',
        placeholderMessage: 'Write your message...',
        labelTo: 'To',
        labelSubject: 'Subject',
        sectionAttachments: 'Attachments',
        sectionComment: 'Comment',
        addItem: 'Add item',
        addPhoto: 'Add photo',
        addPayment: 'Add payment',
        goBack: 'go back',
        dialogShippingInfo: 'Shipping info',
        dialogRecordPayment: 'Record Payment',
        dialogJobDetails: 'Job details',
        labelAmount: 'Amount',
        labelShipDate: 'Ship date',
        labelShipVia: 'Ship via',
        labelTrackingNumber: 'Tracking number',
        labelFob: 'FOB',
        columnDate: 'Date',
        columnType: 'Type',
        msgClientEmailError: 'client email error',
        msgAmountGreaterThanZero: 'The amount must be greater than zero',
        msgInvalidAmount: 'The amount must be between 0 and 999,999,999,999,999 with up to 5 decimal places',
        calculatedAmountOutOfRange: 'Calculated amount exceeds the supported range',
        msgTextTooLong: '{field} cannot exceed {max} characters',
        msgTextTooLongBytes: '{field} cannot exceed {max} UTF-8 bytes',
        msgInvalidJobDetails: 'Job details contain invalid data',
        msgMorePaymentThanBalance: 'More payment than balance due',
        mailSentSuccessfully: 'Mail sent successfully',
        cumulativeTaxNotice: 'Web does not support the accumulation of tax in the invoice...',
        confirmUnsavedChanges: 'You have unsaved changes. Would you like to save or discard them?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Tax,discount and withholding',
        purchaseOrder: 'Purchase Order',
        placeholderPurchaseOrderPrefix: 'purchase order prefix',
        placeholderCreditMemoPrefix: 'credit memo prefix',
        placeholderEstimatePrefix: 'estimate prefix',
        labelStatus: 'Status',
        statusIssued: 'Issued',
        statusApproved: 'Approved',
        statusPending: 'Pending',
        statusWithdrawn: 'Withdrawn',
        tax: 'Tax'
    },
    createEstimate: {
        pageTitlePrefix: 'Add',
        cumulativeTaxNotice: 'Web does not support the accumulation of tax in the estimate...'
    },
    updateInvoice: {
        pageTitlePrefix: 'Update',
        deletePrefix: 'Delete',
        confirmDelete: 'This will delete the invoice. Continue?',
        cumulativeTaxNotice: 'This invoice contains cumulative tax. Web does not support this function temporarily'
    },
    updateEstimate: {
        pageTitlePrefix: 'Update',
        deletePrefix: 'Delete',
        confirmDelete: 'This will delete the {document}. Continue?',
        cumulativeTaxNotice: 'This estimate contains cumulative tax. Web does not support this function temporarily'
    },
    createAccount: {
        title: 'Create a Account',
        placeholderEmail: 'email',
        placeholderPassword: 'Password',
        placeholderCompanyName: 'Company Name',
        createAccountButton: 'Create account',
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign in',
        validEmail: 'Please enter a valid email address',
        validPassword: 'Password must be 6 characters or more',
        validCompanyName: 'Please fill in your company name',
        companyNameTooLong: 'Company name can contain up to {max} characters'
    },
    clientCreate: {
        pageTitle: 'Add client',
        basicInformation: 'Basic information',
        labelName: 'Name',
        placeholderName: 'Enter a name...',
        labelEmail: 'Email',
        placeholderEmail: 'Enter an email address...',
        labelPhone: 'Phone',
        placeholderPhone: 'Enter a phone number...',
        billingAddress: 'Billing address',
        labelLine1: 'Line 1',
        labelLine2: 'Line 2',
        labelLine3: 'Line 3',
        shippingAddress: 'Shipping address',
        sameAsBilling: 'Same as billing address',
        labelShippingName: 'Shipping name',
        labelShippingLine1: 'Line 1',
        labelShippingLine2: 'Line 2',
        labelShippingLine3: 'Line 3',
        labelNotes: 'Notes',
        placeholderNotes: "Add notes about the client. They can't see these",
        defaultDiscount: 'Default discount',
        validDefaultDiscount: 'Please enter a valid default discount',
        validName: 'Please enter a client name',
        validEmail: 'Please enter a valid email address'
    },
    clientUpdate: {
        pageTitle: 'Update client',
        confirmDelete: 'This will delete the client. Continue?'
    },
    itemCreate: {
        pageTitle: 'Add item',
        itemTitle: 'Item',
        labelCost: 'Cost',
        rateSign: 'Rate sign',
        inventorySign: 'Inventory adjustment sign',
        labelUnit: 'Unit',
        placeholderUnit: 'Unit',
        defaultTaxes: 'Default taxes',
        taxOff: 'off',
        inventoryTitle: 'Inventory',
        currentInventory: 'Current inventory',
        adjustInventory: 'Adjust inventory',
        increase: 'Increase',
        decrease: 'Decrease',
        placeholderQuantity: 'Quantity',
        placeholderDateAndTime: 'Date and time',
        placeholderNote: 'Note',
        addButton: 'Add',
        columnDate: 'Date',
        columnQuantity: 'Quantity',
        columnNote: 'Note',
        withholdingTitle: 'Withholding',
        msgInventoryCannotDisable: 'Inventory cannot be disabled after it has been enabled',
        msgDescriptionRequired: 'Item description is required',
        msgInvalidRate: 'Rate must be between -999,999,999,999,999 and 999,999,999,999,999 with up to 4 decimal places',
        msgInvalidCost: 'Cost must be between 0 and 999,999,999,999,999 with up to 5 decimal places',
        msgInvalidInventory: 'Quantity must be between 0 and 999,999,999,999,999 with up to 5 decimal places',
        msgInvalidUnit: 'Unit must not contain && or exceed 255 characters',
        msgQuantityRequired: 'Quantity is required',
        msgDateRequired: 'Date and time is required'
    },
    itemUpdate: {
        pageTitle: 'Edit item',
        columnInvoice: 'Invoice',
        confirmDelete: 'This will delete the item. Continue?'
    },
    createStatement: {
        pageTitle: 'Client Statement',
        tabPreview: 'Preview',
        tabSendEmail: 'Send Email',
        createAction: 'Create Statement',
        from: 'From',
        to: 'To',
        invoices: 'Invoices',
        balanceDue: 'Balance due',
        editTitle: 'Edit Statement',
        startDate: 'Start date',
        endDate: 'End date',
        onlyShowUnpaid: 'Only show unpaid invoices',
        unpaidOnlyActive: 'This statement only includes unpaid invoices.',
        dateRequired: 'Start date and end date are required',
        invalidDateRange: 'End date must not be earlier than start date'
    },
    time: {
        pageTitle: 'Time',
        unbilled: 'Unbilled',
        billed: 'Billed',
        searchPlaceholder: 'Search time by client or description',
        addTime: 'Add time',
        noTime: 'No time entries',
        noTimeDescription: 'Create a time entry to track billable work.',
        noClient: 'No Client',
        filterAndSort: 'Filter and sort',
        year: 'Year',
        groupBy: 'Group by',
        sortBy: 'Sort by',
        order: 'Order',
        yearly: 'Yearly',
        quarterly: 'Quarterly',
        monthly: 'Monthly',
        ascending: 'Ascending',
        descending: 'Descending',
        duration: 'Duration',
        createTitle: 'Create Time',
        editTitle: 'Time',
        selectClient: 'Select a client',
        start: 'Start',
        end: 'End',
        hours: 'hours',
        minutes: 'minutes',
        ratePreset: 'Rate',
        customRate: 'Custom rate',
        rateName: 'Rate name',
        showRateName: 'Show rate name on invoice',
        invalidDate: 'Start and end times are required',
        endBeforeStart: 'End time must not be earlier than start time',
        invalidDuration: 'Duration must match the start and end times',
        invalidRate: 'Rate must be between 0 and 999999999999999 with no more than 5 decimal places',
        rateNameTooLong: 'Rate name cannot exceed 255 characters',
        descriptionTooLong: 'Description cannot exceed 3000 characters',
        confirmDelete: 'This will delete the time entry. Continue?'
    },
    setting: {
        taxInfo: 'Tax Info',
        taxes: 'Taxes',
        taxYearStarts: 'Tax year starts',
        taxYearStartSubtitle: 'Set the first day of the financial year',
        rateLabel: 'Rate(%)',
        abbreviation: 'Abbreviation',
        addTax: 'Add tax',
        month: 'Month',
        day: 'Day',
        monthPlaceholder: 'Month',
        dayPlaceholder: 'Day',
        saveTaxYearStart: 'Save',
        deleteDialogTitle: 'Delete',
        confirmDeleteTax: 'Are you sure delete this tax?',
        deleteConfirm: 'Delete',
        taxInfoDialogTitle: 'Tax Info',
        taxName: 'Tax Name',
        standardRate: 'Standard rate (%)',
        additionalRate: 'Additional rate',
        deleteRateX: 'X',
        addRate: 'Add rate',
        taxType: 'Tax type',
        exclusive: 'Exclusive',
        inclusive: 'Inclusive',
        close: 'close',
        saveTax: 'Save tax',
        cantOpenDetailMessage: 'This tax contains cumulative tax. Web does not support this function temporarily',
        closeButton: 'Close',
        rateIsRequired: 'rate is must',
        rateIsRequiredMsg: 'Rate is a must',
        monthAndDayRequired: 'Month and day are required',
        additionalRateNumber: 'Additional rate {number} (%)',
        taxNameRequired: 'Tax name is required',
        invalidTaxRate: 'Rate must be between 0 and 999999999999999 with no more than 4 decimal places',
        duplicateTaxRate: 'Tax rates must be unique',
        taxRatesTooLong: 'There are too many tax rates to save',
        withholdingNameRequired: 'Abbreviation is required when withholding is active',
        moreRate: ' more rate',
        moreRates: ' more rates'
    },
    companyInfo: {
        title: 'Company Info',
        details: 'Details',
        businessName: 'Business name',
        businessNamePlaceholder: 'Business name',
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        businessNumber: 'Business Number',
        taxNo: 'Tax N°',
        deleteField: 'delete',
        addNewField: 'Add new field',
        address: 'Address',
        line1: 'Line1',
        line2: 'Line2',
        line3: 'Line3',
        currency: 'Currency',
        currencyLabel: 'Currency',
        symbol: 'Symbol',
        placement: 'Placement',
        before: 'Before',
        after: 'After',
        thousandSymbol: 'Thousand Symbol',
        decimalSymbol: 'Decimal Symbol',
        decimalPlaces: 'Decimal Places',
        example: 'Example',
        terms: 'Terms',
        termsLabel: 'Terms',
        termSameDay: 'Same Day',
        term7Days: '7 Days',
        term14Days: '14 Days',
        term21Days: '21 Days',
        term30Days: '30 Days',
        term45Days: '45 Days',
        term60Days: '60 Days',
        term90Days: '90 Days',
        term180Days: '180 Days',
        term365Days: '365 Days',
        paymentInfo: 'Payment Info',
        displayOnInvoices: 'Display on invoices',
        titlePlaceholder: 'Title',
        jobDetails: 'Job Details',
        deleteJobDetail: 'delete',
        addNewJobField: 'add new field',
        fieldNameRequired: '{field}: field name is required',
        reservedCharacters: '{field}: field names cannot contain : or &&, and values cannot contain &&',
        serializedDataTooLong: '{field} data exceeds the database limit',
        textDataTooLong: '{field} exceeds the database limit'
    },
    default: {
        title: 'Default',
        emailMessage: 'Email Message',
        enterDescription: 'Enter a description',
        emailCc: 'Email Cc',
        emailBcc: 'Email Bcc',
        emailTip: 'Send an e-mail at the same time to the address above.',
        defaultComments: 'Default Comments',
        invoice: 'Invoice',
        estimate: 'Estimate',
        purchaseOrder: 'Purchase Order',
        creditMemo: 'Credit Memo',
        emailValidError: 'email valid'
    },
    invoiceDesign: {
        template: 'Template',
        color: 'Color',
        labels: 'Labels',
        labelInvoice: 'Invoice',
        labelEstimate: 'Estimate',
        labelPurchaseOrder: 'Purchase order',
        labelCreditMemo: 'Credit memo',
        labelReceipt: 'RECEIPT',
        labelTermsFormat: 'Terms format',
        labelBillTo: 'Bill to',
        labelFor: 'For',
        labelDate: 'Date',
        labelInvoiceNo: 'Invoice no',
        labelEstimateNo: 'Estimate no',
        labelPoNo: 'PO no',
        labelCreditMemoNo: 'Credit memo no',
        labelDueDate: 'Due date',
        labelTerms: 'Terms',
        labelAmount: 'Amount',
        labelCode: 'Code',
        labelDescription: 'Description',
        labelQuantity: 'Quantity',
        labelRate: 'Rate',
        labelTax: 'Tax',
        labelSubtotal: 'Subtotal',
        labelBalanceDue: 'Balance due',
        labelDiscount: 'Discount',
        labelNonTaxableItem: 'Non-taxable item',
        labelPaid: 'Paid',
        labelShipping: 'Shipping',
        labelTotal: 'Total',
        labelIncludes: 'Includes',
        labelTotalAmountPaid: 'Total Amount Paid',
        labelShipDate: 'Ship Date',
        labelShipTo: 'Ship to',
        labelShipVia: 'Ship via',
        labelTrackingNo: 'Tracking no',
        labelFob: 'F.O.B',
        prefix: 'Prefix',
        prefixInvoice: 'Invoice',
        prefixEstimate: 'Estimate',
        prefixPurchaseOrder: 'Purchase Order',
        prefixCreditMemo: 'Credit Memo',
        nextNumber: 'Next Number',
        numberingBeginsAt: 'Numbering begins at',
        nextNumberInvoice: 'Invoice',
        nextNumberEstimate: 'Estimate',
        nextNumberPurchaseOrder: 'Purchase Order',
        nextNumberCreditMemo: 'Credit Memo',
        options: 'Options',
        optionTerms: 'Terms',
        optionDueDate: 'Due Date',
        optionShippingAddress: 'Shipping address',
        optionProductCode: 'Product code',
        optionQuantityAndRate: 'Quantity and rate',
        optionUnit: 'Unit',
        optionTax: 'Tax',
        optionAmount: 'Amount',
        optionNonTaxableItemStar: 'Non-taxable item star',
        optionDiscount: 'Show Discount',
        optionTaxBreakdown: 'Tax Breakdown',
        optionPaymentHistory: 'Payment history',
        optionStamp: 'Stamp',
        optionPageNumber: 'Page Number',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "Thanks for your business! We hope you are satisfied with our work. Please remit payment within 15 days.Questions? Comments? Contact us at(111)111-1234 or email us at example@owner.com, we'll be happy to answer any questions or concerns.",
        previewSubtotal: 'Subtotal',
        previewVat: 'VAT 17.00%',
        previewPayment1: 'Payment on Oct 1, 2019',
        previewPayment2: 'Payment on Oct 2, 2019',
        invalidNextNumber: 'Each next number must be a whole number between 0 and {max}'
    },
    feedback: {
        title: 'Send Feedback',
        invalidEmailNoticePrefix: 'The email address on your account is invalid, so we were unable to contact you. Please send your feedback from a valid email address to',
        invalidEmailNoticeSuffix: 'If possible, include a screenshot of the issue; it will help us investigate and resolve it.',
        replyTip: 'After sending, please check your email for the reply.',
        contextTip: 'The following account and browser details will be included with your feedback:',
        content: 'Content',
        enterDescription: 'Enter a description',
        contentTooLong: 'Content cannot exceed {max} characters'
    },
    createExpense: {
        title: 'Add Expense',
        description: 'Description',
        expenseDescriptionPlaceholder: 'Expense description',
        total: 'Total',
        tax: 'Tax',
        tip: 'Tip',
        expenseDate: 'Expense Date',
        merchant: 'Merchant',
        merchantPlaceholder: 'Enter merchant name',
        categoryPlaceholder: 'Select category',
        addNewCategory: 'Add new category',
        deletePhoto: 'Delete',
        addPhoto: 'Add photo',
        deleteCategory: 'delete',
        addCategory: 'Add category',
        descriptionTooLong: 'Description cannot exceed 3,000 characters.',
        merchantTooLong: 'Merchant cannot exceed 255 characters.',
        amountInvalid: 'Total, tax, and tip must each be between 0 and 999999999999999, with no more than 5 decimal places.',
        categoryRequired: 'Category name is required.',
        categoryTooLong: 'Category name cannot exceed 255 characters.',
        photoUploadFailed: 'Photo upload failed. Please try again.'
    },
    updateExpense: {
        title: 'Update Expense',
        deleteExpense: 'Delete Expense',
        confirmDeleteMsg: 'This will delete the expense. Continue?'
    },
    notFound: {
        oops: 'OOPS!',
        notFoundMsg: "We can't seem to find the page that you're looking for.",
        takeMeHome: 'Take me home'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Free Shipping',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Computer',
        previewItem2: 'Phone',
        previewItem3: 'Birthday cake',
        previewTaxRate: '17%',
        nonTaxableNote: '* Indicates non-taxable item',
        thanksMessage: "Thanks for your business! We hope you are satisfied with our work. Please remit payment within 15 days.Questions? Comments? Contact us at(111)111-1234 or email us at example@owner.com, we'll be happy to answer any questions or concerns.",
        subtotal: 'Subtotal',
        vat: 'VAT 17.00%',
        payment1: 'Payment on Oct 1, 2019',
        payment2: 'Payment on Oct 2, 2019',
        balanceDue: 'Balance Due'
    }
};
